import "../../resources/CKEEditor.css";

type Props = {
  message: string;
};

const HtmlMessage: React.FC<Props> = ({ message }: Props) => {
  return <div className="ck-content" dangerouslySetInnerHTML={{ __html: message }} />;
};

export default HtmlMessage;
